import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import Select from '../../Elements/Select/Select';
import { translate } from '../../../utils/locale';
import s from './Stockists.scss';

const Stockists = ({ setup, content }) => {
	if (!content.countries) return null;
	const [currentCountry, changeCountry] = useState('');
	const countries = content?.countries || [];
	const countryOptions = [{ key: '', value: translate(setup, 'chooseCountry') }, ...countries.map((c) => ({ key: c.country, value: setup.countries[c.country].name }))];

	const changeCountryHandler = (id, value) => {
		changeCountry(value);
	};

	return (
		<div className={s.stockists}>
			<Select variantClasses={['select__stockists']} id="stockistCountry" options={countryOptions} selected={currentCountry} inputChange={changeCountryHandler} />
			{
				countries.map((c) => {
					if (c.country !== currentCountry && currentCountry !== '') return null;
					return (
						<div key={c.key} className={s.stockists_country}>
							<h5 className={s.stockists_country_title}>{ setup.countries[c.country].name }</h5>
							{
								c.stockists.map((stockist) => {
									const TitleEl = stockist?.link ? 'a' : 'span';
									const titleAttrs = {};
									if (stockist?.link) {
										titleAttrs.href = stockist.link;
										titleAttrs.target = '_blank';
										titleAttrs.rel = 'noreferrer noopener';
									}

									return (
										<div key={stockist.key} className={s.stockist}>
											<TitleEl className={s.stockist_title} {...titleAttrs}>{ stockist.store }</TitleEl>
											<p className={s.stockist_info}>{ translate(setup, stockist.info) }</p>
										</div>
									);
								})
							}
						</div>
					);
				})
			}
		</div>
	);
};

export default hot(module)(Stockists);
